import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Platform } from '@ionic/angular';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
 
  constructor(
    private httpClient: HttpClient,
    private platform: Platform,
    private router: Router
  ) { }

  async getInfo() {
    if (this.platform.is('android') || this.platform.is('ios')) {
      
      const app = await App.getInfo();
      const info = {
        device: (this.platform.is('android')) ? 'android' : 'ios',
        build: app.build,
        version: app.version
      }
      return info;
    }else{
      return 'web';
    }

  }

  async checkUpdates() {
    const info = await App.getInfo();
    this.getVersion().subscribe(
      {
        next: response => {
          if (response.data.state) {
            if (this.platform.is('android') && info.build != response.data.android) {
              this.router.navigateByUrl('update');
            }
            if (this.platform.is('ios') && info.build != response.data.ios) {
              this.router.navigateByUrl('update');
            }
          }

        },
        error: error => {
          console.log(error);
        }
      }
    );
  }

  getVersion(): Observable<any> {
    return this.httpClient.get(`${environment.apiUrl}versions`);
  }
}
